import api from './axios';

export const getUsers = (params) => api.get('/users', { params });
export const getUser = (id) => api.get(`/users/${id}`);
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const resetUserPassword = (id) => api.post(`/users/${id}/reset-password`);
export const getUserPermissions   = (id)      => api.get(`/users/${id}/permissions`);
export const updateUserPermission = (id, data) => api.post(`/users/${id}/permissions`, data);
export const resetUserPermissions = (id)      => api.delete(`/users/${id}/permissions`);